import { useState } from "react";
import useMerchantPortalAxios from "../utils/axios";
import { BaseRequest } from "../utils/Classes/Requests/BaseRequest";
import { useDispatch } from "react-redux";
import { setLBPBalance, setUSDBalance } from "../features/accountBalanceSlice";
import { settingData } from "../features/BSLAccountSlice";

const OverviewAPI = () => {
  const MerchantPortalAxios = useMerchantPortalAxios();
  const [CurBalDOL, setCurBalDOL] = useState([]);
  const [CurBalLBP, setCurBalLBP] = useState([]);
  const [StatBalDOL, setStatBalDOL] = useState([]);
  const [transactionsToApprove, setTransactionsToApprove] = useState([]);
  const [StatBalLBP, setStatBalLBP] = useState([]);
  const [accountLoading, setAccountLoading] = useState(true);
  const [chartLoading, setChartLoading] = useState(true);
  const [approveListLoading, setApproveListLoading] = useState(true);

  const [initiateTransfer, setInitiateTransfer] = useState(null);

  const dispatch = useDispatch();

  async function GetAccountBalance(dateFrom, dateTo) {
    setAccountLoading(true);
    if (sessionStorage.getItem("EntityType") === "MERCHANTEMPLOYEE") return;
    const res = await MerchantPortalAxios.post(
      `/v1/Overview/GetAccountBalance`,
      {
        SessionID: sessionStorage.getItem("SessionID"),
        DateFrom: dateFrom,
        DateTo: dateTo,
      }
    );

    if (
      res.data.Payload.CurrenciesOverview[0] &&
      res.data.Payload.CurrenciesOverview[0].CurrencyBalances
    ) {
      if (
        res.data.Payload.CurrenciesOverview[0].CurrencyBalances.Book !== null
      ) {
        sessionStorage.setItem(
          "usdAmount",
          res.data.Payload.CurrenciesOverview[0].CurrencyBalances.Available.toLocaleString(
            "en-US"
          )
        );
      } else {
        sessionStorage.setItem("usdAmount", "0");
      }

      setCurBalDOL(res.data.Payload.CurrenciesOverview[0].CurrencyBalances);
      dispatch(
        setUSDBalance(
          res.data.Payload.CurrenciesOverview[0].CurrencyBalances?.Available
        )
      );
      setAccountLoading(false);
    }

    if (
      res.data.Payload.CurrenciesOverview[1] &&
      res.data.Payload.CurrenciesOverview[1].CurrencyBalances
    ) {
      if (
        res.data.Payload.CurrenciesOverview[1].CurrencyBalances.Book !== null
      ) {
        sessionStorage.setItem(
          "lbpAmount",
          res.data.Payload.CurrenciesOverview[1].CurrencyBalances.Available.toLocaleString(
            "en-US"
          )
        );
      } else {
        sessionStorage.setItem("lbpAmount", "0");
      }
      setCurBalLBP(res.data.Payload.CurrenciesOverview[1].CurrencyBalances);
      dispatch(
        setLBPBalance(
          res.data.Payload.CurrenciesOverview[1].CurrencyBalances?.Available
        )
      );
    }
  }

  async function GetSOAChartsDataByCurrency(dateFrom, dateTo, currency) {
    setChartLoading(true);
    await MerchantPortalAxios.post(`/v1/Overview/GetSOAChartsDataByCurrency`, {
      SessionID: sessionStorage.getItem("SessionID"),
      DateFrom: dateFrom,
      DateTo: dateTo,
      Currency: currency,
    }).then((res) => {
      setStatBalDOL(res?.data?.Payload?.LegalSOAChart?.ChartsPoints);
      setStatBalLBP(res?.data?.Payload?.LegalSOAChart?.ChartsPoints);
      setChartLoading(false);
    });
  }

  async function GetBankAccountChartsDataByCurrency(
    dateFrom,
    dateTo,
    currency
  ) {
    setChartLoading(true);
    await MerchantPortalAxios.post(
      `/v1/Overview/GetBankAccountChartsDataByCurrency`,
      {
        SessionID: sessionStorage.getItem("SessionID"),
        DateFrom: dateFrom,
        DateTo: dateTo,
        Currency: currency,
      }
    ).then((res) => {
      setStatBalDOL(res?.data?.Payload?.LegalSOAChart?.ChartsPoints);
      setStatBalLBP(res?.data?.Payload?.LegalSOAChart?.ChartsPoints);
      setChartLoading(false);
    });
  }

  async function GetTransactionsToApprove() {
    const req = new BaseRequest(sessionStorage.getItem("SessionID"));
    await MerchantPortalAxios.post(
      `/v1/Overview/GetTransactionsToApprove`,
      req
    ).then((res) => {
      setTransactionsToApprove(res.data.Payload.TransactionsAwaitingApproval);
      setApproveListLoading(false);
    });
  }

  async function ApproveRejectAwaitingTrx(payload) {
    const res = await MerchantPortalAxios.post(
      `/v1/Overview/ApproveRejectAwaitingTrx`,
      payload
    );

    return res.data.Payload;
  }

  async function ApproveListAwaitingTrx(payload) {
    const res = await MerchantPortalAxios.post(
      `/v1/Overview/ApproveListAwaitingTrx`,
      payload
    );

    return res.data.Payload;
  }

  async function InitiateTransferToLegal() {
    const req = new BaseRequest(sessionStorage.getItem("SessionID"));
    await MerchantPortalAxios.post(
      `/v1/EODClosing/InitiateTransferToLegal`,
      req
    ).then((res) => {
      setInitiateTransfer(res.data.Payload);
    });
  }

  const ConfirmTransferToLegal = async (payload) => {
    const res = await MerchantPortalAxios.post(
      `/v1/EODClosing/ConfirmTransferToLegal`,
      payload
    );
    return res.data;
  };

  const GetBankAccountBalance = async (dateFrom, dateTo) => {
    try {
      const response = await MerchantPortalAxios.post(
        "/v1/Overview/GetBankAccountBalance",
        {
          SessionID: sessionStorage.getItem("SessionID"),
          DateFrom: dateFrom,
          DateTo: dateTo,
        }
      );

      const currenciesOverview = response.data.Payload.CurrenciesOverview;

      dispatch(
        settingData({ field: "currenciesOverview", value: currenciesOverview })
      );

      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

  return {
    GetAccountBalance,
    // GetSOAChartsData,
    GetTransactionsToApprove,
    ApproveRejectAwaitingTrx,
    ApproveListAwaitingTrx,
    InitiateTransferToLegal,
    ConfirmTransferToLegal,
    CurBalDOL,
    CurBalLBP,
    StatBalDOL,
    StatBalLBP,
    accountLoading,
    chartLoading,
    transactionsToApprove,
    approveListLoading,
    initiateTransfer,
    setInitiateTransfer,
    GetBankAccountBalance,
    GetSOAChartsDataByCurrency,
    GetBankAccountChartsDataByCurrency,
  };
};
export default OverviewAPI;
